import React from 'react';
import { ErrorMessageDetails, ErrorMessageTitle } from './components';
import { parseError } from 'shared/../helpers/errorParser';
// Styles
import './style.scss';
import { theme } from 'src/theme';

if (theme.mode === 'dark') {
  import(/* webpackChunkName: "dark" */ './style.scss?dark');
}

const ErrorMessage = ({ children, message, error }) => (
  <div className="error-message">
    <div><span className="k-icon k-i-error error-message-icon" /></div>
    <div className="error-message-content">
      {message && <ErrorMessageTitle>{message}</ErrorMessageTitle>}
      {error && <ErrorMessageDetails>{parseError(error)}</ErrorMessageDetails>}
      {children}
    </div>
  </div>
);

export default ErrorMessage;
